const APP_PATH = 'app';

// const APP_URL = "http://hva-shop.harrys:8000/app";
const APP_URL = "https://shop.hva.gr/app";

const APP_VERSION = '1.0.0';

const PRODUCT_TYPE = {
    PRODUCT: 0,
    SERVICE: 1,
}

const PAYMENT_METHOD = {
    CARD: 0,
    COD: 1,
    BANK: 2,
}

const SHIPPING_METHOD = {
    COURIER: 0,
    STORE: 1,
}

const ORDER_STATUS = {
    ON_PAYMENT: 0,
    NEW: 1,
    ON_PROGRESS: 2,
    SENT: 3,
    COMPLETED: 4,
    RETURNED: 5,
    CANCELED: 6,
    FAILED: 7,
}

const PASSWORD_TIP = "Ο κωδικός πρέπει να αποτελείται από 6 και άνω χαρακτήρες και να περιέχει λατινικά γράμματα, σύμβολα ή και αριθμούς.";

export {
    APP_PATH,
    APP_URL,
    APP_VERSION,
    PRODUCT_TYPE,
    PAYMENT_METHOD,
    SHIPPING_METHOD,
    ORDER_STATUS,
    PASSWORD_TIP,
}